const designAdviceSchema = {
  categories: [],
  types: [],
  advice: [],
};

export default designAdviceSchema;
